import { http } from '../api/client';

export const eventService = {
    // Admin endpoints
    getEvents: (queryParams) => http.get('/event', { params: queryParams }),
    getEventById: (id) => http.get(`/event/${id}`),
    createEvent: (data, config) => http.post('/event/create', data, config),
    updateEvent: (data, config) => http.post('/event/update', data, config),
    publishEvent: (id) => http.post('/event/publish', { id }),

    // Logged-in users
    getActiveEvents: () => http.get('/event/active'),

    // Public endpoints
    getPublicEvents: () => http.get('/public/events'),
    getPublicEventById: (id) => http.get(`/public/event/${id}`),
};
